import { FC } from 'react';

import cx from 'classnames';
import { ToggleLayer } from 'react-laag';

import styles from './index.module.css';
import { LegacyVariant } from './LegacyVariant';
import { SearchableVariant } from './SearchableVariant';
import { IInlineSelectProps } from './types';

const InlineSelect: FC<IInlineSelectProps> = ({
  value,
  options = [],
  onChange,
  lowercaseLabel,
  renderLabel,
  minWidth = 115,
  searchable,
  groups,
  groupBy,
  renderOption,
  searchFn,
}) => {
  const selectedOption = value ? options.find((option) => option.value === value) || null : null;

  return (
    <ToggleLayer
      renderLayer={(props) =>
        searchable ? (
          <SearchableVariant
            selectedOption={selectedOption}
            renderOption={renderOption}
            groups={groups}
            groupBy={groupBy}
            onChange={onChange}
            options={options}
            minWidth={minWidth}
            searchFn={searchFn}
            {...props}
          />
        ) : (
          <LegacyVariant onChange={onChange} minWidth={minWidth} options={options} {...props} />
        )
      }
      placement={{
        anchor: 'BOTTOM_CENTER',
        autoAdjust: true,
        triggerOffset: 15,
      }}
      closeOnOutsideClick
      fixed
    >
      {({ triggerRef, toggle }) => {
        return (
          <span
            ref={triggerRef}
            onClick={toggle}
            className={cx(styles.togglerLabel, lowercaseLabel && styles.togglerLabelLowercase)}
          >
            {renderLabel ? renderLabel(selectedOption) : selectedOption && selectedOption.label}
          </span>
        );
      }}
    </ToggleLayer>
  );
};

export default InlineSelect;
